import { http } from '../../config/axios'

export default function inativarPlano(idPlano: string): Promise<string> {
  return http
    .patch('api/plano/inativar/' + idPlano)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro inativarPlano', error)
      throw Error(error.response.data)
    })
}
